document.addEventListener('DOMContentLoaded', function () {
  var launcher = document.getElementById('bionny-launcher');
  if (!launcher) return;

  var chatOpen = false;
  var shown = false;
  launcher.style.display = 'none';

  launcher.addEventListener('click', function () {
    if (window.$chatwoot) {
      window.$chatwoot.toggle(chatOpen ? 'close' : 'open');
    }
  });

  window.addEventListener('chatwoot:opened', function () {
    chatOpen = true;
    launcher.classList.add('is-open');
  });

  window.addEventListener('chatwoot:closed', function () {
    chatOpen = false;
    launcher.classList.remove('is-open');
  });

  function reveal() {
    if (shown) return;
    shown = true;
    launcher.style.display = 'flex';
    window.removeEventListener('scroll', onScroll);
  }

  function onScroll() {
    var scrollable = document.body.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    var scrollPercent = (window.scrollY / scrollable) * 100;
    if (scrollPercent >= 25) reveal();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(reveal, 15000);
});